import { cn } from '@/lib/utils';

import type { EntityAccessPerson } from '../types/types';

type PersonRowProps = {
  person: EntityAccessPerson;
  selected?: boolean;
  onSelected?: () => void;
};

export const PersonRow = ({ person, selected, onSelected }: PersonRowProps) => {
  const { email, firstName, lastName } = person.user;
  const displayName = `${firstName ?? ''} ${lastName ?? ''}`.trim() || email;
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <button
      type="button"
      className={cn(
        'flex w-full items-center gap-2 rounded-[6px] py-[3px] pl-3 pr-1 text-left text-sm leading-5 transition-colors',
        selected ? 'bg-[#07b4c0] text-white' : 'text-primary-dark hover:bg-primary-light/10'
      )}
      onClick={onSelected}
    >
      <span
        className={cn(
          'flex size-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
          selected ? 'bg-white/25 text-white' : 'bg-primary-light/10 text-primary'
        )}
      >
        {initial}
      </span>
      <div className="flex flex-col">
        <span className="min-w-0 truncate text-sm font-semibold">
          {' '}
          {`${firstName ?? ''} ${lastName ?? ''}`.trim()}
        </span>
        <span className="min-w-0 truncate text-[10px] font-semibold">{email}</span>
      </div>
    </button>
  );
};
